module.exports = __webpack_public_path__ + "img/red_045.b0e81c20.png";